import LeaseIndustryJson from './leaseIndustry.js';
import { LeaseRegWrapper } from './industryWrapper.js';

var { DeviceRecycling, CreditQuery, Usury, EFPL, Financial, Lease, PrivateCar, RealEstate } = LeaseIndustryJson;
Lease = LeaseRegWrapper( Lease );

export function formattedAmount ( number ){
    if(!number) return '0.00';
    return number.toLocaleString('zh-CN', { 
        style: 'currency', 
        currency: 'CNY', 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
    });
}

export function FINDER ( array, str ){
    if( !str ) return false;
    return array.some( item => {
        if( item instanceof RegExp ) {
            return item.test(str);
        }
        else {
            return str.indexOf( item ) > -1;
        }
    });
}

//分析订单场景
export function analyzeOrder ( item ) {
    if(FINDER(Lease, item.PARTY) || FINDER(Lease, item.TYPE) || FINDER(Lease, item.TRADING)) {
        return "Lease";
    }
    else if(FINDER(Financial, item.PARTY) || FINDER(Financial, item.TYPE)) {
        return "Financial";
    }
    else if(FINDER(Usury, item.PARTY) || FINDER(Usury, item.TYPE) || FINDER(Usury, item.TRADING)) {
        return "Usury";
    }
    else if(FINDER(EFPL, item.PARTY) || FINDER(EFPL, item.TYPE) || FINDER(EFPL, item.TRADING)) {
        return "Usury";
    }
    else if(FINDER(DeviceRecycling, item.PARTY) || FINDER(DeviceRecycling, item.TYPE) || FINDER(DeviceRecycling, item.TRADING)) {
        return "DeviceRecycling";
    }
    else if(FINDER(CreditQuery, item.PARTY) || FINDER(CreditQuery, item.TYPE) || FINDER(CreditQuery, item.TRADING)) {
        return "CreditQuery";
    }
    else if(FINDER(PrivateCar, item.PARTY) || FINDER(PrivateCar, item.TYPE) || FINDER(PrivateCar, item.TRADING)) {
        return "PrivateCar";
    }
    else if(FINDER(RealEstate, item.PARTY) || FINDER(RealEstate, item.TYPE) || FINDER(RealEstate, item.TRADING)) {
        return "RealEstate";
    }
}
